/**
 * not-found.route — catch-all
 *
 * 🎯 **บอกตรง ๆ ว่าหน้ายังไม่มี ดีกว่าหน้าขาว** — กลุ่มผู้ใช้ 60+ (BRD §8) แยกไม่ออก
 *    ระหว่าง "หน้ายังไม่ถูกสร้าง" กับ "แอปพัง" ถ้าไม่มีอะไรขึ้นเลย
 *
 * ℹ️ path จาก `pathOf()` ที่หน้ายังไม่ถูกสร้าง (`/pdpa-consent` · `/profile-setup` ·
 *    `/login-error`) จะมาลงที่นี่จนกว่าจะถึงคิวของมันในแผน
 */
import { useLocation } from 'react-router';

export function NotFoundRoute() {
  const { pathname } = useLocation();
  return (
    <main>
      <h1>ยังไม่มีหน้านี้</h1>
      <p>
        หน้า <code>{pathname}</code> จะถูกสร้างในวันถัดไปของแผน
      </p>
    </main>
  );
}
